import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import ForumIcon from "@mui/icons-material/Forum";
import Groups2Icon from "@mui/icons-material/Groups2";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import LockIcon from "@mui/icons-material/Lock";
import { titleImageOf } from "../../lib/titleImage";
import { titleRatio } from "../../lib/titleProgress";

/** Aile simgesi (mobil familyIcon ile aynı eşleme). */
export function FamilyIcon({ family, ...props }) {
  if (family === "muzakere") return <ForumIcon {...props} />;
  if (family === "meclis") return <Groups2Icon {...props} />;
  if (family === "odak") return <TimerOutlinedIcon {...props} />;
  if (family === "hatim") return <MenuBookIcon {...props} />;
  return <LocalFireDepartmentIcon {...props} />;
}

/** Rengi koyulaştırır (madalyona derinlik veren alt ton). */
export function shade(hex) {
  const value = String(hex || "").replace("#", "");
  if (!/^[0-9a-fA-F]{6}$/.test(value)) return hex;
  const nums = [0, 2, 4].map((i) => parseInt(value.slice(i, i + 2), 16));
  return `#${nums.map((n) => Math.max(0, Math.round(n * 0.72)).toString(16).padStart(2, "0")).join("")}`;
}

/**
 * Eşiğe göre ilerleme yüzdesi (kazanılmışsa 100). İki şartlı ünvanda
 * (also) az tamamlanmış şart esas alınır.
 */
export function titlePercent(title) {
  if (!title) return 0;
  if (title.earned) return 100;
  return Math.min(100, Math.round(titleRatio(title) * 100));
}

/**
 * Yuvarlak madalyon: kazanıldıysa seviyenin renginde, kilitliyse soluk ve
 * kilit simgeli. Dış halka kazanılanlarda rengin açık tonunu alır.
 */
export function Medal({ title, family, size = 58 }) {
  const src = titleImageOf(title, family);
  if (src) return <TitleBadgeImage title={title} src={src} size={size} />;
  const earned = Boolean(title?.earned);
  const inner = size - 10;
  return (
    <span
      className={`rounded-full flex items-center justify-center shrink-0 border-2 ${
        earned ? "" : "border-terakkiBrandMist dark:border-white/[0.14]"
      }`}
      style={{ width: size, height: size, borderColor: earned ? `${title.color}66` : undefined }}
    >
      <span
        className={`rounded-full flex items-center justify-center ${
          earned ? "text-white" : "bg-terakkiBrandMist text-terakkiNeutral dark:bg-white/10 dark:text-white/70"
        }`}
        style={{
          width: inner,
          height: inner,
          background: earned ? `linear-gradient(160deg, ${title.color}, ${shade(title.color)})` : undefined,
        }}
      >
        {earned ? (
          <FamilyIcon family={family} sx={{ fontSize: Math.round(size * 0.38) }} aria-hidden />
        ) : (
          <LockIcon sx={{ fontSize: Math.round(size * 0.28) }} aria-hidden />
        )}
      </span>
    </span>
  );
}

/**
 * Rozet resmi: kazanıldıysa olduğu gibi; kilitliyse soluk, yarı gri ve
 * köşesinde küçük kilit.
 */
export function TitleBadgeImage({ title, src, size = 58 }) {
  const earned = Boolean(title?.earned);
  const lock = Math.max(14, Math.round(size * 0.3));
  return (
    <span
      className="relative inline-flex items-center justify-center shrink-0"
      style={{ width: size, height: size }}
      data-badge={earned ? "earned" : "locked"}
    >
      <img
        src={src}
        alt={title?.name || ""}
        width={size}
        height={size}
        loading="lazy"
        draggable={false}
        className="block w-full h-full object-contain select-none"
        style={earned ? undefined : { opacity: 0.35, filter: "grayscale(0.6)" }}
      />
      {earned ? null : (
        <span
          data-testid="title-lock"
          className="absolute bottom-0 right-0 rounded-full flex items-center justify-center bg-terakkiSurface text-terakkiNeutral border border-terakkiBorder dark:bg-[#123B3D] dark:text-white/75 dark:border-white/15"
          style={{ width: lock, height: lock }}
        >
          <LockIcon sx={{ fontSize: Math.round(lock * 0.62) }} aria-hidden />
        </span>
      )}
    </span>
  );
}

/**
 * Küçük rozet resmi (sıralama etiketi, özet şeridi). Resim yoksa (bilinmeyen
 * kod) fallback çizilir; böylece eski veride mevcut görünüm korunur.
 */
export function TitleThumb({ title, family, size = 16, fallback = null, className = "" }) {
  const src = titleImageOf(title, family);
  if (!src) return fallback;
  return (
    <img
      src={src}
      alt=""
      aria-hidden
      width={size}
      height={size}
      loading="lazy"
      draggable={false}
      data-title-thumb={title?.code}
      className={`inline-block shrink-0 object-contain select-none ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
